import styled from 'styled-components';

import OverlayLoader from '@formstack/phoenix/components/Loader/OverlayLoader';

export const StyledOverlayLoader = styled(OverlayLoader)`
  align-items: flex-start !important;
  padding-top: 133px !important;
`;

export const StyledOverlayLoaderContainer = styled.div`
  position: relative;
  padding: 2px;
` as any;
